module.exports = __webpack_public_path__ + "static/media/twitter.404e63c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.svg
// module id = 619
// module chunks = 0